module.exports = __webpack_public_path__ + "9246a8036a9c2c55eedbfe2c81daef71.jpg";